import api from "./api";

export const AdminBookingAPI = {
  /* =============================
   * LIST BOOKINGS
   * ============================= */
  list(params = {}) {
    return api.get("/api/admin/bookings", { params });
  },

    /* =============================
   * DASHBOARD STATS
   * ============================= */
  stats() {
    return api.get("/api/admin/bookings/booking-stats");
  },

  /* =============================
   * VERIFY BOOKING
   * ============================= */
  verify(id) {
    if (!id) throw new Error("Booking ID required");
    return api.post(`/api/admin/bookings/${id}/verify`);
  },

  /* =============================
   * REJECT BOOKING
   * ============================= */
  reject(id, payload = {}) {
    if (!id) throw new Error("Booking ID required");
    return api.post(
      `/api/admin/bookings/${id}/reject`,
      payload
    );
  },

  /* =============================
   * RESEND TICKET
   * ============================= */
  resendTicket(id) {
    if (!id) throw new Error("Booking ID required");
    return api.post(`/api/admin/bookings/${id}/resend-ticket`);
  },

  /* =============================
   * RESCUE BOOKING (EXPIRED → PAID)
   * ============================= */
  rescue(id) {
    if (!id) throw new Error("Booking ID required");
    return api.post(`/api/admin/bookings/${id}/rescue`);
  },

  /* =============================
   * EXPORT CSV
   * ============================= */
  exportCSV(params = {}) {
    return api.get("/api/admin/bookings/export", {
      params,
      responseType: "blob",
    });
  },

  /* =============================
   * EXPORT ATTENDANCE LIST CSV
   * ============================= */
  exportAttendance(params = {}) {
    return api.get("/api/admin/bookings/export-attendance", {
      params,
      responseType: "blob",
    });
  },

  /* =============================
   * BULK CHECK-IN (upload CSV)
   * ============================= */
  bulkCheckin(file) {
    const form = new FormData();
    form.append("csv", file);
    return api.post("/api/admin/bookings/bulk-checkin", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
